import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "enableBottomSeparator", "enableEffects", "selectedElementIds", "expandedElementIds"];
import React, { forwardRef, Fragment } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useNavigationClassNames } from './hooks/useNavigationClassNames';
import { useNavigation } from './hooks/useNavigation';
import { NavigationRoot } from './style';
import { NAVIGATION_CLASS_PREFIX, DEFAULT_MAX_DEPTH_LEVEL } from './constants';
import { Menu, MenuElement } from '../Menu';

var isElementInState = function isElementInState(element, stateName, elementIds) {
  if (element[stateName] !== undefined) {
    return element[stateName];
  }

  if (elementIds) {
    return elementIds.includes(element.id);
  }

  return false;
};

var renderMenuElement = function renderMenuElement(element, depthLevel) {
  var maxDepthLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MAX_DEPTH_LEVEL;
  var parentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var enableEffects = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var onMenuElementClick = arguments.length > 5 ? arguments[5] : undefined;
  var selectedElementIds = arguments.length > 6 ? arguments[6] : undefined;
  var expandedElementIds = arguments.length > 7 ? arguments[7] : undefined;

  if (depthLevel >= maxDepthLevel) {
    return null;
  }

  var hasChildren = !!(element.items && element.items.length);
  var globalId = "".concat(parentId, ".").concat(element.id);
  var elementExpanded = isElementInState(element, 'expanded', expandedElementIds);
  var elementSelected = isElementInState(element, 'selected', selectedElementIds);
  return React.createElement(Fragment, {
    key: element.id
  }, React.createElement(MenuElement, Object.assign({}, element.menuElementProps, {
    enableExpansionHandle: hasChildren,
    secondary: depthLevel === 1,
    tertiary: depthLevel > 1,
    "data-menuelementid": element.id,
    "data-menuelementglobalid": globalId,
    "data-depthlevel": depthLevel,
    depthLevel: depthLevel,
    expanded: elementExpanded,
    "data-expanded": elementExpanded,
    selected: elementSelected,
    onClick: onMenuElementClick
  }), element.label), element.beforeMenu, hasChildren && React.createElement(Menu, {
    secondary: depthLevel === 0,
    tertiary: depthLevel > 0,
    expanded: elementExpanded,
    enableEffects: enableEffects
  }, element.beforeItems, element.items.map(function (subItem) {
    return renderMenuElement(subItem, depthLevel + 1, maxDepthLevel, globalId, enableEffects, onMenuElementClick, selectedElementIds, expandedElementIds);
  }), element.afterItems), element.afterMenu);
};

export var Navigation = forwardRef(function Navigation(_ref, ref) {
  var className = _ref.className,
      enableBottomSeparator = _ref.enableBottomSeparator,
      enableEffects = _ref.enableEffects,
      selectedElementIds = _ref.selectedElementIds,
      expandedElementIds = _ref.expandedElementIds,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(NAVIGATION_CLASS_PREFIX);
  var classNameComponents = useNavigationClassNames(NAVIGATION_CLASS_PREFIX, className);

  var _useNavigation = useNavigation(restProps),
      onMenuElementClick = _useNavigation.onMenuElementClick,
      items = _useNavigation.items,
      maxDepthLevel = _useNavigation.maxDepthLevel,
      restRootProps = _useNavigation.restRootProps;

  return React.createElement(NavigationRoot, Object.assign({}, restRootProps, {
    theme: theme,
    className: classNameComponents.Root,
    ref: ref
  }), React.createElement(Menu, {
    enableBottomSeparator: enableBottomSeparator
  }, !!items && items.map(function (item) {
    return renderMenuElement(item, 0, maxDepthLevel, '', enableEffects, onMenuElementClick, selectedElementIds, expandedElementIds);
  })));
});
Navigation.defaultProps = {
  maxDepthLevel: DEFAULT_MAX_DEPTH_LEVEL,
  enableBottomSeparator: false,
  enableEffects: true,
  items: []
};